import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';

const container = document.getElementById('root');
const root = createRoot(container);

// Wrap App in ErrorBoundary to catch the white screen errors
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);